import { Inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { LOGIN_URL } from "./tokens";

export class ExpiredTokenHandler {
    constructor(
        protected router: Router,
        protected activatedRoute: ActivatedRoute) {

    }

    public handle(loginUrl:string) {
        if (!this.activatedRoute.snapshot.queryParams["redirectUrl"]) {
            this.router.navigateByUrl(`${loginUrl}?redirectUrl=${encodeURIComponent(window.location.href)}`);
        }
    }



}